import { Item, ItemType } from '@inno-sdks/files'
import { AppId } from '@inno-tools/container-bridge'
import { DEFAULT_SHORTCUT_ITEM_SIZE } from 'modules/desktop/constants'

import type { SystemShortcutConfig } from './systemShortcut.types'

const GRANT_APPLICATION_MODAL = 'new-grant-application'
const GRANT_APPLICATION_SOURCE = 'shortcut'

const isNewGrantApplicationDeepLink = (value: string): boolean => {
  try {
    const url = new URL(value, window.location.origin)

    return (
      url.searchParams.get('modal') === GRANT_APPLICATION_MODAL &&
      url.searchParams.get('source') === GRANT_APPLICATION_SOURCE
    )
  } catch {
    return false
  }
}

export const NEW_GRANT_APPLICATION_SHORTCUT = {
  key: 'new-grant-application',
  name: 'New grant application',
  shortcutUrl: `${process.env.REACT_APP_DOMAIN}/?modal=${GRANT_APPLICATION_MODAL}&source=${GRANT_APPLICATION_SOURCE}`,
  displayNameKey: 'new_grant_application',
  iconAppId: AppId.SUBSIDIES,
  action: 'openNewGrantApplication',
  deepLink: {
    matches: isNewGrantApplicationDeepLink,
    consumedSearchParams: ['modal', 'source']
  },
  presentation: {
    itemType: 'shortcut',
    label: 'New grant application',
    iconType: 'image',
    icon: '/app-icons/subsidies.webp',
    isPinned: false,
    isPermanent: true,
    position: { row: 0, col: 0 },
    size: DEFAULT_SHORTCUT_ITEM_SIZE,
    onClick: {
      type: 'openUrl',
      url: `${process.env.REACT_APP_DOMAIN}/?modal=${GRANT_APPLICATION_MODAL}&source=${GRANT_APPLICATION_SOURCE}`
    }
  }
} satisfies SystemShortcutConfig

/** Ignores origin so matching survives a different REACT_APP_DOMAIN per environment. */
const normalizeUrl = (value: string): string => {
  try {
    return new URL(value, window.location.origin).pathname
  } catch {
    return value
  }
}

/** Identifies the provisioned system shortcut without relying on its file id. */
export const isNewGrantApplicationShortcut = (item: Item): boolean =>
  item.type === ItemType.Shortcut &&
  item.name === NEW_GRANT_APPLICATION_SHORTCUT.name &&
  item.extra?.isPermanent === true &&
  normalizeUrl(item.metaData.shortcutUrl) ===
    normalizeUrl(NEW_GRANT_APPLICATION_SHORTCUT.shortcutUrl)
